import { memo } from 'react';
import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import MultiDimensionTableOpzV2 from 'pages/PlanPageDetailsOPZ/Inputs/IndicatorPageMultiDim/MultiDimensionTableOpzV2';
import { getIndicatorTableData } from 'redux/PlanPageSlice';

import './BuilderModeMultiDimTableV1.scss';

export interface BuilderModeMultiDimTableV1Properties {
  isPercentage: string;
  refetchRequest: () => void;
}

const BuilderModeMultiDimTableV1 = memo(
  ({ isPercentage, refetchRequest }: BuilderModeMultiDimTableV1Properties) => {
    const indicatorTableData = useSelector(getIndicatorTableData);
    const isConstantTable = indicatorTableData?.type === 'constant';

    return (
      <Box
        className={`builder-mode-v1-multidim-table${
          isConstantTable ? ' builder-mode-v1-fit-content' : ''
        }`}
        w={isConstantTable ? 'fit-content' : '100%'}
        maxW='100%'
        alignSelf={isConstantTable ? 'flex-start' : undefined}
        flex={isConstantTable ? '0 0 auto' : 1}
        minH={isConstantTable ? undefined : 0}
        h={isConstantTable ? 'auto' : '100%'}
        display='flex'
        flexDirection='column'
        overflow={isConstantTable ? 'visible' : 'hidden'}
      >
        <MultiDimensionTableOpzV2
          refetchRequest={refetchRequest}
          isPercentage={isPercentage}
          isBuilderMode
          isBuilderModeV1
        />
      </Box>
    );
  },
);

BuilderModeMultiDimTableV1.displayName = 'BuilderModeMultiDimTableV1';

export default BuilderModeMultiDimTableV1;
